var map = {
	"./icon--area.svg": 49330,
	"./icon--back.svg": 63908,
	"./icon--bullet.svg": 86665,
	"./icon--cafe.svg": 74306,
	"./icon--calendar.svg": 48739,
	"./icon--celebrating.svg": 58561,
	"./icon--celery.svg": 47075,
	"./icon--charity.svg": 77695,
	"./icon--chevron-left.svg": 19676,
	"./icon--chevron-right.svg": 32931,
	"./icon--close.svg": 55403,
	"./icon--coeliac.svg": 93729,
	"./icon--crab.svg": 3735,
	"./icon--eat.svg": 55437,
	"./icon--edit.svg": 83365,
	"./icon--establishment.svg": 37166,
	"./icon--facebook.svg": 30869,
	"./icon--filter.svg": 50543,
	"./icon--gluten.svg": 95466,
	"./icon--group.svg": 20766,
	"./icon--heart-empty-thin.svg": 91105,
	"./icon--heart-empty.svg": 86679,
	"./icon--heart-filled.svg": 33948,
	"./icon--info.svg": 57341,
	"./icon--insta.svg": 5526,
	"./icon--link.svg": 68381,
	"./icon--linkedin.svg": 33579,
	"./icon--loading-white.svg": 21671,
	"./icon--loading.svg": 84743,
	"./icon--location.svg": 66092,
	"./icon--loyalty.svg": 24589,
	"./icon--marker.svg": 70051,
	"./icon--marketing.svg": 51811,
	"./icon--mental.svg": 32110,
	"./icon--menu.svg": 64284,
	"./icon--performance.svg": 421,
	"./icon--phone.svg": 96179,
	"./icon--pound.svg": 41173,
	"./icon--pub.svg": 85430,
	"./icon--restaurant.svg": 16420,
	"./icon--review.svg": 55473,
	"./icon--search.svg": 43185,
	"./icon--searching.svg": 88287,
	"./icon--shape.svg": 78164,
	"./icon--socialmedia.svg": 89256,
	"./icon--sort.svg": 97873,
	"./icon--stop.svg": 13345,
	"./icon--tick.svg": 24126,
	"./icon--tiktok.svg": 90423,
	"./icon--twitter.svg": 2146,
	"./icon--verified.svg": 91157,
	"./icon--verified2.svg": 69085,
	"./icon--web.svg": 24561,
	"./logo--dark.svg": 19179,
	"./next.svg": 4843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63394;